import React from "react"
import PropTypes from "prop-types"

import "./header.scss"

const Header = ({ title }) => (
  <header styleName="onboarding-header">
    <div styleName="spacer" />
    <h1>{title}</h1>
    <div styleName="spacer" />
  </header>
)

Header.propTypes = {
  title: PropTypes.string.isRequired,
}

export default Header
